import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function EmailNewsletter() {
  return (
    <ToolShell
      testid="tool-newsletter-page" eyebrow="Pro Tool" toolKey="newsletter" title="Email Newsletter Builder"
      subtitle="A polished weekly newsletter in your voice."
      endpoint="/tools/email-newsletter" tier="pro" transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "theme", label: "This week's theme", type: "text", required: true, placeholder: "e.g. Why student retention beats new student acquisition" },
        { key: "key_points", label: "3-5 key points you want to cover", type: "textarea", rows: 4 },
        { key: "audience_note", label: "Any specific audience note? (optional)", type: "text" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="Subject" copyValue={o.subject}>{o.subject}</OutputBlock>
          <OutputBlock label="Preview text">{o.preview_text}</OutputBlock>
          <OutputBlock label="Title">{o.title}</OutputBlock>
          <OutputBlock label="Intro"><div className="whitespace-pre-wrap leading-relaxed">{o.intro}</div></OutputBlock>
          {(o.sections || []).map((s, i) => (
            <div key={i} className="dms-card p-5"><h3 className="font-heading font-bold text-[16px] text-[#0A2342]">{s.heading}</h3><div className="mt-2 whitespace-pre-wrap leading-relaxed text-[14.5px]">{s.body}</div></div>
          ))}
          {o.tip_of_the_week && <OutputBlock label="Tip of the week">{o.tip_of_the_week}</OutputBlock>}
          {o.this_weeks_question && <OutputBlock label="Engagement prompt">{o.this_weeks_question}</OutputBlock>}
          {o.cta && <OutputBlock label="CTA">{o.cta}</OutputBlock>}
          {o.ps && <OutputBlock label="P.S.">{o.ps}</OutputBlock>}
        </>
      )}
    />
  );
}
